import { render } from "./RegisterComponent.vue?vue&type=template&id=41bbc4da&scoped=true"
import script from "./RegisterComponent.vue?vue&type=script&lang=js"
export * from "./RegisterComponent.vue?vue&type=script&lang=js"

import "./RegisterComponent.vue?vue&type=style&index=0&id=41bbc4da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bbc4da"]])

export default __exports__